import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase'
import { withContext, getContext, withHandlers,lifecycle } from 'recompose'
import PropTypes from 'prop-types'

import {
  // selectSubreddit,fetchPostsIfNeeded,invalidateSubreddit,

  selectAssessment,invalidateAssessment,
  initBreadcrumb,addBreadcrumb,
  formatEmployee
} from '../actions'

import {
  generateAssessments
} from '../../admin/actions'


import { invalidateActivity } from '../../activities/actions'
/*
import {insertWordTable} from '../actions-office'
import formatAssessment from '../actions-assessment'
import formatAssessment from '../actions-assessment-multi-indicator'
import {getAssessmentsByEmployeeId, getActivities} from '../reducers'
*/

import {generatePrefixes,generateAssesments} from '../../admin/services/generate-accounts'

import Assessments from '../components/Assessments'



function mapStateToProps(state, ownProps) {
  
  const { selectedAssessment, selectedActivity, breadcrumbs, activitiesByAssessmentId, 
    store, firebase: { auth, profile}, assessments, activities, adminState   } = state

  const { isFetching, items } = assessments || { isFetching: true, items: []}

  /*
      const {
  
    isFetching,
    lastUpdated,
    items: posts
  } = activitiesByAssessmentId[selectedAssessment] || {
    isFetching: true,
    items: [],
  }

  //const assessmentsByEmployeeId = getAssessmentsByEmployeeId(state)
  //const activitiesByEmployeeId =  getActivities(state)
  */


  return {
    
    assessments: items,
    
    activities,
    selectedAssessment,
    selectedActivity,
    
    breadcrumbs,
    activitiesByAssessmentId,
    isFetching,
    //lastUpdated,
    store,
    auth, profile,
    adminState
  }
  
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        invalidateAssessment: () => { 
          dispatch(invalidateActivity())
          dispatch(invalidateAssessment())
        },

        invalidateActivity: () => { dispatch(invalidateActivity())},

        addBreadcrumb: (breadcrumb) => { dispatch(addBreadcrumb(breadcrumb))},
        handlePersonaClick: (assessment, breadcrumbs) => {
          dispatch(selectAssessment(assessment))
          dispatch(initBreadcrumb(breadcrumbs))
        },

        generateAssessments: (raterId,name,prefix,activity,total) => {
          console.log(raterId)
          /*
            const prefixes = generatePrefixes(name,prefix,activity,total)
            generateAssesments(raterId,prefixes).map(value => {
              value.then(item => console.log(item))
            })
            
            */
        },

        formatEmployee: (data) => { dispatch(formatEmployee(data))  }


    }
}


const withStore = compose(
  withContext({ store: PropTypes.object }, () => {}),
  getContext({ store: PropTypes.object }),
)

export default compose(
/*
  withFirebase,
*/
  firebaseConnect(),
  withStore,
  withHandlers({
    loadData: ({store }) => err => store.firestore.get('assessmentsByRater')
  }),
  lifecycle({
    componentDidMount() {
      this.props.loadData()      
    }
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )
)(Assessments)










// WEBPACK FOOTER //
// ./src/assessments/containers/Assessments.js